<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>
        <b-card>
          <form action="">
            <div class="form-row mt-1">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                <select v-model="search_data.mouza_id"  id="mouza_id" name="mouza_id" class="form-control form-control-sm">
                  <option :value="''" selected>Select Mouza</option>
                  <option v-for="(mouza, index) in mouzas" v-bind:value="mouza.id" :key="index">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>

          </form>
        </b-card>

        <b-card>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Mouza</th>
                <th>Plot No.</th>
                <th>Acquired Land(PS)</th>
                <th>CCL Number(AB)</th>
                <th>Total Land(AB)</th>
                <th>Plot No.(AB)</th>
                <th>Mouza(AB)</th>
                <th>Mouza(CCL)</th>
                <th>CCL Amount(CCL)</th>
                <th>Total Land(CCL)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ccl, index) in ccls.data" :key="index">
                <td>{{ ccls.from + index }}</td>
                <td>{{ ccl.mouza_id }}</td>
                <td>{{ ccl.plot_no }}</td>
                <td>{{ ccl.ps_acquired_land }}</td>
                <td>{{ ccl.ab_ccl_amount }}</td>
                <td>{{ ccl.ab_total_land }}</td>
                <td>{{ ccl.ab_plot_no }}</td>
                <td>{{ ccl.ab_mouza_id }}</td>
                <td>{{ ccl.ccl_mouza_id }}</td>
                <td>{{ ccl.ccl_ccl_amount }}</td>
                <td>{{ ccl.ccl_total_land }}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5 class="text-center text-secondary" v-if="ccls.total === 0 || !flag">
              No Data Found
            </h5>
            <div class="float-right mt-1">
              <pagination :data="ccls" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "List of CCL",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "List of CCL",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of CCL",
          active: true
        }
      ],
      search_data: {
        mouza_id: '',
      },
      mouzas: [],
      ccls: {},
      flag: false,
      loader: false,
      btn_edit: false,
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/dataCrossCheck/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.mouzas = data.mouzas;
        }
      });
    },
    search() {
      this.flag = true
      this.loader = true
      http.post("api/psAbCcls/search", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.ccls = response.data.ccls;
        }
      });
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http.post('api/psAbCcls/search?page=' + page, this.search_data)
          .then(response => {
            this.flag = true;
            this.loader = false
            this.ccls = response.data.ccls;
          });
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
